module.exports = __webpack_public_path__ + "static/media/user@2x.32551925.png";